














/* Created- 04 - Apr - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import { eParticaAction, ParticaEvent } from "../../../Models/ParticaEvent";
@Component(
	{
		name: "ArticleLinkedin"
	})
export default class ArticleLinkedin extends Vue {
	@Prop() private linkedin: string;
	private changed(event: any) {
		this.$emit("update:linkedin", event);
		this.$emit("partica-event", { action: eParticaAction.PROPERTY_CHANGED } as ParticaEvent);
	}

}
